import { CategoryData } from '../../../../types/types';

export const animaux: CategoryData = {
    // Animaux sauvages
    'Wara': { translation: 'Lion', translationEn: 'Lion', illustration: '🦁', audio: 'Ba-wara' },
    'Wakaninkalan': { translation: 'Lionceau', translationEn: 'Lion cub', illustration: '🦁', audio: 'Ba-wakaninkalan' },
    'Sama': { translation: 'Éléphant', translationEn: 'Elephant', illustration: '🐘', audio: 'Ba-sama' },
    'Waraba': { translation: 'Panthère/Léopard', translationEn: 'Panther/Leopard', illustration: '🐆' },
    'Ngolo': { translation: 'Singe', translationEn: 'Monkey', illustration: '🐒' },
    'Miniyan': { translation: 'Antilope', translationEn: 'Antelope', illustration: '🦌' },
    'Yele': { translation: 'Girafe', translationEn: 'Giraffe', illustration: '🦒' },
    'Kuru': { translation: 'Zèbre', translationEn: 'Zebra', illustration: '🦓' },
    'Dugu': { translation: 'Hyène', translationEn: 'Hyena', illustration: '🐺' },
    'Jara': { translation: 'Gazelle', translationEn: 'Gazelle', illustration: '🦌' },
    'Jingo': { translation: 'Hippopotame', translationEn: 'Hippopotamus', illustration: '🦛' },
    'Suma': { translation: 'Buffle', translationEn: 'Buffalo', illustration: '🐃' },
    'Wurukunma': { translation: 'Guépard', translationEn: 'Cheetah', illustration: '🐆' },
    'Juru': { translation: 'Gnou', translationEn: 'Wildebeest', illustration: '🐃' },
    'Gbanangban': { translation: 'Phacochère', translationEn: 'Warthog', illustration: '🐗' },

    // Animaux domestiques
    'Wulu': { translation: 'Chien', translationEn: 'Dog', illustration: '🐕', audio: 'Ba-wulu' },
    'Kongowulu': { translation: 'Chiot', translationEn: 'Puppy', illustration: '🐕', audio: 'Ba-kongowulu' },
    'Jakuma': { translation: 'Chat', translationEn: 'Cat', illustration: '🐈', audio: 'Ba-jakuma' },
    'Sise': { translation: 'Poule', translationEn: 'Hen', illustration: '🐔', audio: 'Ba-sise' },
    'Ba': { translation: 'Chèvre', translationEn: 'Goat', illustration: '🐐' },
    'Saga': { translation: 'Mouton', translationEn: 'Sheep', illustration: '🐑', audio: 'Ba-saga' },
    'Misi': { translation: 'Vache', translationEn: 'Cow', illustration: '🐄', audio: 'Ba-misi' },
    'Kongomisi': { translation: 'Veau', translationEn: 'Calf', illustration: '🐄', audio: 'Ba-kongomisi' },
    'Soo': { translation: 'Cheval', translationEn: 'Horse', illustration: '🐎', audio: 'Ba-soo' },
    'Lee': { translation: 'Âne', translationEn: 'Donkey', illustration: '🐴', audio: 'Ba-lee' },
    'Fali': { translation: 'Bœuf', translationEn: 'Ox', illustration: '🐃', audio: 'Ba-fali' },
    'Kongofali': { translation: 'Veau', translationEn: 'Calf', illustration: '🐃', audio: 'Ba-kongofali' },
    'Nogome': { translation: 'Bouc', translationEn: 'Billy goat', illustration: '🐐', audio: 'Ba-nogome' },
    'Kongonogueme': { translation: 'Chevreau', translationEn: 'Kid (young goat)', illustration: '🐐' },

    // Reptiles et amphibiens
    'Saa': { translation: 'Serpent', translationEn: 'Snake', illustration: '🐍', audio: 'Ba-saa' },
    'Sula': { translation: 'Crapaud', translationEn: 'Toad', illustration: '🐸', audio: 'Ba-sula' },
    'Mankalanin': { translation: 'Crocodile', translationEn: 'Crocodile', illustration: '🐊', audio: 'Ba-mankalanin' },

    // Oiseaux
    'Kono': { translation: 'Oiseau', translationEn: 'Bird', illustration: '🐦', audio: 'Ba-kono' },
    'Duga': { translation: 'Vautour', translationEn: 'Vulture', illustration: '🦅' },
    'Kungofen': { translation: 'Pigeon sauvage', translationEn: 'Wild pigeon', illustration: '🕊️' },
    'Dogo': { translation: 'Aigle', translationEn: 'Eagle', illustration: '🦅' },
    'Kala': { translation: 'Perroquet', translationEn: 'Parrot', illustration: '🦜' },
    'Beri': { translation: 'Hibou', translationEn: 'Owl', illustration: '🦉' },

    // Insectes
    'Di': { translation: 'Abeille', translationEn: 'Bee', illustration: '🐝', audio: 'Ba-di' },
    'Soso': { translation: 'Moustique', translationEn: 'Mosquito', illustration: '🦟' },
    'Birinini': { translation: 'Papillon', translationEn: 'Butterfly', illustration: '🦋' },
    'Dimi': { translation: 'Fourmi', translationEn: 'Ant', illustration: '🐜' },
    'Kumata': { translation: 'Criquet', translationEn: 'Grasshopper', illustration: '🦗' },
    'Tulu': { translation: 'Mouche', translationEn: 'Fly', illustration: '🪰', audio: 'Ba-tulu' }
};

export default animaux;
